// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3s9zo","label":"Category_label__sxw5o","content":"Category_content__1b1fp","header":"Category_header__1eBiy","location":"Category_location__VhMt_"};